// extracted by mini-css-extract-plugin
module.exports = {"container":"i_f0","item":"i_f1","sign":"i_f2","left":"i_f3","right":"i_f4","tick":"i_f5","heading":"i_f6","label":"i_f7","value":"i_f8","suffix":"i_f9"};